export default __webpack_public_path__ + "static/walk_dog-fae00bb7e0adc6bb78d981e0e133e9ec.svg";